export class SirenAlert {

    id: number;
    name: string;
    pathUrl: string;

    constructor() {}
}
